import { NgxPermissionsGuard } from 'ngx-permissions';
import { USER_LEVEL } from 'src/app/constants/user.level.constants';

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { FeatureFlagGuardService } from '../../services/core/feature-flag-guard.service';
import { AdditionalDocumentsResolver } from '../../services/resolvers/additional-documents-resolver.service';
import { HealthRecordComponent } from './health-record.component';
import { OtherDocumentsComponent } from './other-documents/other-documents.component';

const healthRecordRoutes: Routes = [
	{
		path: '',
		redirectTo: 'report',
		pathMatch: 'full',
	},
	{
		path: 'report',
		component: HealthRecordComponent,
		data: {
			title: 'Health Documents',
		},
	},
	{
		path: 'biometric/results',
		component: HealthRecordComponent,
		canActivate: [NgxPermissionsGuard],
		data: {
			permissions: {
				except: [USER_LEVEL.MATCHED.valueOf()],
				redirectTo: '/dashboard',
				pathMatch: 'full',
			},
			title: 'Health Documents - Biometric Results',
		},
	},
	{
		path: 'additional',
		component: OtherDocumentsComponent,
		canActivate: [FeatureFlagGuardService],
		resolve: { resolvedData: AdditionalDocumentsResolver },
		data: {
			title: 'Additional Health Documents',
			featureFlag: 'AdditionalHealthDocuments',
		},
	},
];

@NgModule({
	imports: [RouterModule.forChild(healthRecordRoutes)],
	exports: [RouterModule],
})
export class HealthRecordRoutingModule {}
